module.exports = __webpack_public_path__ + "static/media/hondurasflag.814817b0.png";